import { TOsiraseGetListRes } from "../../../service/master/osirase/TOsirase"
import { TModalTypes, ModalOuter } from "../../../components/Modal/ModalOuter"
import dayjs from "dayjs"
import * as wjCore from "@grapecity/wijmo"
import { faExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const OsiraseModal: React.FC<
  TModalTypes & {
    Osirase: TOsiraseGetListRes | undefined
  }
> = (props) => {
  let spanClassName = ""
  let iconClassName = "mx-1"

  if (props.Osirase?.強調表示フラグ) {
    spanClassName += " text-danger"
    iconClassName += " d-inline"
  } else {
    iconClassName += " d-none"
  }

  const TitleComponent: React.FC<{
    osirase: TOsiraseGetListRes | undefined
  }> = ({ osirase }) =>
    wjCore.isNullOrWhiteSpace(osirase?.タイトル ?? "") ? (
      <>{props.title}</>
    ) : (
      <span className={spanClassName}>
        <FontAwesomeIcon
          icon={faExclamation}
          className={iconClassName}></FontAwesomeIcon>
        {osirase?.タイトル}
      </span>
    )

  return (
    <ModalOuter
      isShow={props.isShow}
      setIsShow={props.setIsShow}
      title={<TitleComponent osirase={props.Osirase}></TitleComponent>}
      size={"xl"}
      dialogClassName={""}
      isDisabledCloseButton={false}>
      <div>
        <textarea className="w-100 min-h-20rem" readOnly>
          {props.Osirase?.内容}
        </textarea>
      </div>
      <div className="text-end">
        (<span className="me-2">{props.Osirase?.更新ユーザ氏名}</span>
        <span className="">
          {props.Osirase?.更新日時
            ? dayjs(props.Osirase?.更新日時).format("YYYY/MM/DD HH:mm:ss")
            : undefined}
        </span>
        )
      </div>
    </ModalOuter>
  )
}
